import { useQuery } from "@tanstack/react-query";
import { getPrescriptions } from "../services/get-prescriptions";
import { PaginatedPrescriptions } from "../types/prescription";

export default function usePrescriptions(
  page: number = 0,
  search?: string,
  status?: string,
  document_type?: string,
  tags?: string,
  start_date?: string,
  end_date?: string,
  professional_id?: string,
) {
  const { data, isLoading, error, isFetching, isSuccess } =
    useQuery<PaginatedPrescriptions>({
      queryKey: [
        "prescriptions",
        {
          page,
          search,
          status,
          document_type,
          tags,
          start_date,
          end_date,
          professional_id,
        },
      ],
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
      queryFn: () =>
        getPrescriptions({
          page,
          search,
          status,
          document_type,
          tags,
          start_date,
          end_date,
          professional_id,
        }),
    });

  return { data, isLoading, error, isFetching, isSuccess };
}
